// adding letters only validation

const rule = {
	name: 'lettersonly',
	method: (value, element, params) => /^[a-z \'\-]+$/i.test(value),
	errorMessage: (params, element) => 'Letters only please'
};

export default rule;
